import { type LoaderFunctionArgs } from '@remix-run/node'
import { useParams } from '@remix-run/react'
import { TypographyDisplay, TypographyCaps, TypographyLabel } from '#app/components/typography'
export async function loader({ params }: LoaderFunctionArgs) {
  return null
}

export default function UnsupportedChain() {
  const { chain } = useParams()

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-4">
      <TypographyCaps
        size="medium"
        additionalClasses="text-textSecondaryLight dark:text-textSecondaryLight"
      >ATOMIC LORE</TypographyCaps>
      <TypographyDisplay
        size="medium"
        additionalClasses="py-4 text-textPrimaryLight dark:text-textPrimaryDark break-words">
          Unsupported Chain
      </TypographyDisplay>
      <TypographyLabel
        size="medium"
        additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
        This NFT is on a blockchain we currently don't support.
      </TypographyLabel>
      {/* <TypographyLabel
        size="medium"
        additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
        Be the first to know when we add new chain support and features.
      </TypographyLabel> */}
    </div>
  )
}

export function ErrorBoundary() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <p>Something went wrong while loading this page.</p>
    </div>
  )
} 